<div class="scrollViewport">
	<ng-content />
</div>
<div class="staticActions">
	@if (menuActions().length) {
		<button
			mat-fab
			matTooltipPosition="left"
			matTooltipClass="accent"
			[matMenuTriggerFor]="actionsMenu"
			[matTooltip]="T.ACTION_TOOLTIP_ADDITIONAL_ACTIONS | translate"
		>
			<mat-icon fontIcon="fa-ellipsis-v" fontSet="fas" />
		</button>
		<mat-menu #actionsMenu="matMenu" xPosition="before" overlapTrigger>
			@for (menuAction of menuActions(); track $index) {
				@if (menuAction.condition !== false) {
					<button mat-menu-item (click)="menuAction.click()">
						<span class="menuButtonContent">
							<mat-icon [fontIcon]="menuAction.fontIcon" fontSet="fas" inline color="accent" />
							{{ menuAction.labelKey | translate }}
						</span>
					</button>
				}
			}
		</mat-menu>
	}
	@for (action of actions(); track $index) {
		<button
			mat-fab
			matTooltipPosition="left"
			(click)="action.click()"
			[color]="action.color ?? 'accent'"
			[matTooltip]="action.tooltip | translate"
			[matTooltipClass]="action.color ?? 'accent'"
			[disabled]="action.disabled"
		>
			<mat-icon [fontIcon]="action.fontIcon" fontSet="fas" matButtonIcon />
		</button>
	}
</div>
